import React, { PropTypes } from 'react';
import { Item } from '../../components';

const ListItem = ({ letter, color, items }) => (
  <ul className="glossary-list">
    <li className={`letter-separator ${color}`} id={letter} data-letter={letter}>
      {letter}
    </li>
    {items.map((item, index) => <Item key={index} {...item} />)}
  </ul>
);

ListItem.defaultProps = {
  items: []
};

ListItem.propTypes = {
  letter: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      term: PropTypes.string.isRequired,
      letter: PropTypes.string.isRequired,
      definition: PropTypes.string.isRequired,
      subitems: PropTypes.object
    })
  )
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/ListItem/ListItem.js